module.exports = function() {
  return new Worker(__webpack_public_path__ + "eed541ee9b6b7bd6e81e.worker.js");
};